import axiosIns from '../../../xaxios';
import { obtenerUrlAPIPagos } from '../utils/funciones';

export default {
  async create(data) {
    return await axiosIns.post(obtenerUrlAPIPagos('solicitudes-pagos'), data);
  },
  async findAll(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('solicitudes-pagos'), { params: opciones.params });
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIPagos(`solicitudes-pagos/${id}`));
  },
  async update(id, data) {
    return await axiosIns.patch(obtenerUrlAPIPagos(`solicitudes-pagos/${id}`), data);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIPagos(`solicitudes-pagos/${id}`));
  },
  async findAllPaginado(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('solicitudes-pagos/paginado'), { params: opciones.params });
  },
  async findAllPorProgramaUniversidadIdYConceptoUniversidadId(opciones = { params: {} }) {
    return await axiosIns.get(obtenerUrlAPIPagos('solicitudes-pagos/programas-universidades-conceptos-universidades'), {
      params: opciones.params,
    });
  },
  async findAllPorProgramaUniversidadDetallePlanPagoConceptoUniversidadId(opciones = { params: {} }) {
    return await axiosIns.get(
      obtenerUrlAPIPagos('solicitudes-pagos/programas-universidades-detalles-planes-pagos-conceptos-universidades'),
      {
        params: opciones.params,
      },
    );
  },
};
